import { createProvider } from '@/vue-apollo';
import Errors from '@/library/Errors';
import VueApollo from 'vue-apollo';
import Vue from 'vue';

Vue.use(VueApollo);

const vueInstance = new Vue({
  apolloProvider: createProvider(),
});

export default class Mutation
{
  constructor () {
    this.error = false;
    this.errors = new Errors();
    this.loading = false;
    this.success = false;
    this.data = {};
  }

  mutate (mutation, variables) {
    this.error = false;
    this.loading = true;
    this.success = false;
    this.data = {};

    return new Promise((resolve, reject) => {
      vueInstance.$apollo.mutate({
        mutation,
        variables,
      })
      .then(response => {
        const data = response.data;
        const dataKeys = Object.keys(data);

        if (dataKeys.length > 0) {
          const mutationResponse = data[dataKeys[0]];

          if (mutationResponse.hasOwnProperty('errors') && mutationResponse.errors) {
            this.onError(mutationResponse);

            reject(response);
          } else {
            this.onSuccess(response);
          }
        }

        resolve(response);
      })
      .catch(response => {
        response.errors = this.onNetworkError(response);

        reject(response);
      })
      .finally(() => {
        this.onFinally();
      });
    })
  }

  onSuccess ({ data }) {
    this.success = true;

    this.data = data[Object.keys(data)[0]];
  }

  onError (data) {
    this.error = true;

    this.errors.parse(data);

    return data;
  }

  onNetworkError (data) {
    this.errors.parseNetwork(data);

    this.error = true;

    return data;
  }

  onFinally () {
    this.loading = false;
  }

  reset () {
    this.error = false;
    this.errors = new Errors();
    this.loading = false;
    this.success = false;
    this.data = {};
  }
}
